//import React from 'react';
//import { Container, Row, Col, Form, Button } from 'react-bootstrap';
//
//const Footer = () => (
//  <footer className="footer pt-5 pb-5 pd-b-30">
//    <Container>
//      
//      <Row className="justify-content-between mb-5 g-xl-5">
//        <Col md={4} className="mb-5 mb-lg-0">
//           <p style={{ color: '#000000', fontSize: '20px' }}><span className="clr-p w-600">HamaraBill</span>Book</p>
//          <p className="mb-4 clr-blk">
//Powering Small Businesses with Smart Billing.
//</p>
//        </Col>
//        <Col md={7}>
//          <Row className="g-2">
//            <Col md={6} lg={4} className="mb-4 mb-lg-0">
//              <h3 className="mb-3 clr-p w-600">Links</h3>
//              <ul className="list-unstyled">
//                <li><a href="/page-about.html">Home</a></li>
//                <li><a href="/page-careers.html">About</a></li>
//                <li><a href="/page-case-studies.html">How-it-works</a></li>
//                <li><a href="/page-terms-conditions.html">Pricing</a></li>
//                <li><a href="/page-privacy-policy.html">Contact</a></li>
//              </ul>
//            </Col>
//            <Col md={6} lg={4} className="mb-4 mb-lg-0">
//              <h3 className="mb-3 clr-p w-600">Accounts</h3>
//              <ul className="list-unstyled">
//                <li><a href="/page-signup.html">Register</a></li>
//                <li><a href="/page-signin.html">Sign in</a></li>
//                <li><a href="/page-forgot-password.html">Fogot Password</a></li>
//                <li><a href="/page-coming-soon.html">Coming soon</a></li>
//                <li><a href="/page-portfolio-masonry.html">Portfolio Masonry</a></li>
//              </ul>
//            </Col>
//            {/*<Col md={6} lg={4} className="mb-4 mb-lg-0 quick-contact">
//              <h3 className="mb-3 clr-p w-600">Contact</h3>
//              <a className="d-flex mb-3" href="#"><i className="bi bi-geo-alt-fill me-3"></i><span>123 Main Street Apt 4B Springfield, <br /> IL 62701 United States</span></a>
//              <a className="d-flex mb-3" href="mailto:info@mydomain.com"><i className="bi bi-envelope-fill me-3"></i><span>info@mydomain.com</span></a>
//              <a className="d-flex mb-3" href="tel://+123456789900"><i className="bi bi-telephone-fill me-3"></i><span>+1 (234) 5678 9900</span></a>
//              <a className="d-flex mb-3" href="https://freebootstrap.net/"><i className="bi bi-globe me-3"></i><span> </span></a>
//            </Col>*/}
//
//<Col md={6} lg={4} className="mb-4 mb-lg-0 quick-contact">
//  <h3 className="mb-3 clr-p w-600">Contact</h3>
//  <a className="d-flex mb-3" href="https://www.google.com/maps/search/?api=1&query=1+M+60+STC+HOUSING+BOARD+RIICO+Road+Bharatpur+321001+Rajasthan" target="_blank" rel="noopener noreferrer">
//    <i className="bi bi-geo-alt-fill me-3"></i>
//    <span>1 M 60 STC HOUSING BOARD,<br />RIICO Road, Bharatpur 321001, Rajasthan</span>
//  </a>
//  <a className="d-flex mb-3" href="mailto:info.hamarabill@gmail.com">
//    <span className="icon-mail"></span>
//    <span>info.hamarabill@gmail.com</span>
//  </a>
//  <a className="d-flex mb-3" href="tel:+919414419941">
//    <i className="bi bi-telephone-fill me-3"></i>
//    <span>+91 94144 19941</span>
//  </a>
//</Col>
//
//
//          </Row>
//        </Col>
//      </Row>
//      <Row className="credits pt-3">
//        <Col xl={8} className="text-center text-xl-start mb-3 mb-xl-0 clr-blk">
//          &copy; {new Date().getFullYear()} HamaraBill Book. All rights reserved. 
//        </Col>
//      </Row>
//    </Container>
//  </footer>
//);
//
//export default Footer; 





import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="footer pt-5 pb-5">
    <Container>
      <Row className="justify-content-between mb-5 g-xl-5">
        <Col md={4} className="mb-5 mb-lg-0 text-center text-md-start">
          <p style={{ color: '#000000', fontSize: '20px' }}>
            <span className="clr-p w-600">HamaraBill</span>Book
          </p>
          <p className="mb-4 clr-blk">
            Powering Small Businesses with Smart Billing.
          </p>
        </Col>

        <Col md={7}>
          <Row className="g-3 text-center text-md-start">
            <Col md={6} lg={4} className="mb-4 mb-lg-0">
              <h3 className="mb-3 clr-p w-600">
                <Link to="/" className="text-decoration-none clr-p">Links</Link>
              </h3>
              <ul className="list-unstyled">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/how-it-works">How-it-works</Link></li>
                <li><Link to="/pricing">Pricing</Link></li>
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/terms">Terms of Service</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </Col>

            <Col md={6} lg={4} className="mb-4 mb-lg-0">
              <h3 className="mb-3 clr-p w-600">Accounts</h3>
              <ul className="list-unstyled">
                <li><Link to="/register">Register</Link></li>
                <li><Link to="/login">Sign in</Link></li>
                <li><Link to="/forgot-password">Forgot Password</Link></li>
                <li><Link to="/coming-soon">Coming soon</Link></li>
                <li><Link to="/portfolio">Portfolio Masonry</Link></li>
              </ul>
            </Col>

            <Col md={6} lg={4} className="mb-4 mb-lg-0">
              <h3 className="mb-3 clr-p w-600">Contact</h3>
              <a className="d-flex mb-3 justify-content-center justify-content-md-start" href="https://www.google.com/maps/search/?api=1&query=1+M+60+STC+HOUSING+BOARD+RIICO+Road+Bharatpur+321001+Rajasthan" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-geo-alt-fill me-3"></i>
                <span>1 M 60 STC HOUSING BOARD,<br />RIICO Road, Bharatpur 321001, Rajasthan</span>
              </a>
              <a className="d-flex mb-3 justify-content-center justify-content-md-start" href="mailto:info.hamarabill@gmail.com">
                <i className="bi bi-envelope-fill me-3"></i>
                <span>info.hamarabill@gmail.com</span>
              </a>
              <a className="d-flex mb-3 justify-content-center justify-content-md-start" href="tel:+919414419941">
                <i className="bi bi-telephone-fill me-3"></i>
                <span>+91 94144 19941</span>
              </a>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="credits pt-3">
        <Col className="text-center clr-blk">
          &copy; {new Date().getFullYear()} <strong>HamaraBill Book</strong>. All rights reserved.
          <br />
          <span style={{ fontSize: '12px', color: '#888' }}>Developed by Infinex Technologies</span>
        </Col>
      </Row>
    </Container>
  </footer>
);

export default Footer;
